

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const DOWNLOADALLDESIGNATIONS= createAsyncThunk(
  "downloadAllDesignations/downloadAllDesignations",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const downloadAllDesignationsSlice = createSlice({
  name: "downloadAllDesignationsSlice",
  initialState: {
    downloadAllDesignations: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfdownloadAllDesignations: (state) => {
        state.downloadAllDesignations.loading = false
        state.downloadAllDesignations.error = false
        state.downloadAllDesignations.data = []
        state.downloadAllDesignations.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(DOWNLOADALLDESIGNATIONS.fulfilled, (state, action) => {
      state.downloadAllDesignations = {
        ...state.downloadAllDesignations,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DOWNLOADALLDESIGNATIONS.pending, (state, action) => {
      state.downloadAllDesignations = {
        ...state.downloadAllDesignations,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DOWNLOADALLDESIGNATIONS.rejected, (state, action) => {
      state.downloadAllDesignations = {
        ...state.downloadAllDesignations,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const downloadAllDesignationsAction = {
    DOWNLOADALLDESIGNATIONS,
};

export { downloadAllDesignationsAction };
export default downloadAllDesignationsSlice.reducer;
export const {setInitialStateOfdownloadAllDesignations} = downloadAllDesignationsSlice.actions
